type ButtonProps = {
  style?: React.CSSProperties;
  to: string;
  value: string;
  className?: string;
  handleClick: (to: string) => void;
};

export const Button = ({ style, to, value, className, handleClick }: ButtonProps) => {

  const handleButtonClick = (to: string) => {
    handleClick(to);
  };

  return (
    <button className={className} style={style} onClick={() => handleButtonClick(to)}>
      {value}
    </button>
  );
};
